import { render, staticRenderFns } from "./text-button.vue?vue&type=template&id=29f3a3a4&"
import script from "./text-button.vue?vue&type=script&lang=js&"
export * from "./text-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports